import React, { useState } from 'react';

import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const FormDescriptionForm = () => {
  const { page, updatePage } = usePage();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Form
      initialValues={{
        description: page.description,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updatePage.mutateAsync(values);

        actions.resetForm({
          values: {
            description: data.description,
          },
        });

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'description',
          type: 'rich-text',
          placeholder: 'Add info about your form',
          onLoading: setIsLoading,
        },
      ]}
      submitButton={{
        label: 'Save',
        disabled: isLoading,
      }}
    />
  );
};

export default FormDescriptionForm;
